module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "setting-display grey lighten-4"
  }, [_c('div', {
    staticClass: "setting-display-wrapper"
  }, [(_vm.userRole === _vm.staffRoleName || _vm.userRole === _vm.viewerRoleName) ? _c('span', {
    staticClass: "caption hidden-xs-only orange--text"
  }, [_vm._v(_vm._s(_vm.$t('account.function-limit')))]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "setting-display-innner",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/settings_icon01@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "mb-2 pl-2"
  }, [_vm._v(_vm._s(_vm.$t("settings.display-setting")))])]), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(_vm._s(_vm.$t("settings.unit")))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['gal', 'liter'],
      "label": _vm.unit,
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.unit),
      callback: function($$v) {
        _vm.unit = $$v
      },
      expression: "unit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(_vm._s(_vm.$t("settings.pressureUnit")))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['PSI', 'MPa'],
      "label": _vm.pressureUnit,
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.pressureUnit),
      callback: function($$v) {
        _vm.pressureUnit = $$v
      },
      expression: "pressureUnit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md4": ""
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(_vm._s(_vm.$t("settings.temperatureUnit")))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['°C', '°F'],
      "label": _vm.temperatureUnit,
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.temperatureUnit),
      callback: function($$v) {
        _vm.temperatureUnit = $$v
      },
      expression: "temperatureUnit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-subheader', {
    staticClass: "px-0"
  }, [_vm._v(_vm._s(_vm.$t("settings.timezone")))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.selectItemsTimezone,
      "item-text": "text",
      "item-value": "value",
      "label": _vm.timezone,
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.timezone),
      callback: function($$v) {
        _vm.timezone = $$v
      },
      expression: "timezone"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "offset-sm1": "",
      "offset-md1": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/settings_icon02@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("settings.available-sensor")))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#flowsensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.flow")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.flow")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#tdssensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.tds")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.tds")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#pressuresensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.pressure")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.pressure")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#leakagesensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.leakage")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.leakage")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/plugins#temperaturesensor"
    }
  }, [_vm._v(_vm._s(_vm.$t("sensor.temperature")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("sensor.temperature")))])], 1)])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/settings_icon03@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("settings.life-and-notification")))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4 grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.notification-presets")))])]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/notifications_mail"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.notification-mail")))])], 1)])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "offset-sm1": "",
      "offset-md1": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "image-box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/settings_icon04@2x.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("settings.organization-user")))])]), _vm._v(" "), (_vm.userRole === _vm.rootRoleName) ? _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4"
  }, [_c('router-link', {
    attrs: {
      "to": "/settings/pc_list"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.pc-management")))])], 1)]) : _c('ul', {
    staticClass: "mt-4 setting-display-menu"
  }, [_c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.staffRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/organizations_detail"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.management-organization")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.management-organization")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "mr-4"
  }, [(_vm.userRole !== _vm.staffRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/user_list"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.user-management")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.user-management")))])], 1), _vm._v(" "), _c('li', [(_vm.userRole !== _vm.staffRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('router-link', {
    attrs: {
      "to": "/settings/user_invite"
    }
  }, [_vm._v(_vm._s(_vm.$t("settings.user-invitation")))]) : _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t("settings.user-invitation")))])], 1)])])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-62869fd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsDisplay.vue
// module id = 1935
// module chunks = 0